import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {environment} from "../../environments/environment";
import {PartnerBannerActionsDgSearchResults} from "../models/datagrid-search-results/partner-banner-actions.dg-search-results.model";
import {PartnerBannerActionsService} from "../providers/partner-banners-actions.service";

@Injectable()
export class PartnerBannersActionResolve implements Resolve<PartnerBannerActionsDgSearchResults> {
  constructor(private partnerBannersActionsService: PartnerBannerActionsService, private appStateService: AppStateService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<PartnerBannerActionsDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
      return this.partnerBannersActionsService.getResults( environment.DEFAULT_RESULTS_LIMIT,0,'ASC','created').pipe(tap(res => {
        this.appStateService.updateIsBusySubject(false);
      }));
  }
}
